var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalleryhead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 536,
    height: 77,
    viewBox: "0 0 536 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 77L536 77V0L65 0V77Z",
    fill: "#F5F6F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77H53L53 0H42L42 77Z",
    fill: "#F5F6F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 77H32L32 0H21L21 77Z",
    fill: "#F5F6F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 77H11L11 0H0L0 77Z",
    fill: "#F5F6F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryhead);
export default __webpack_public_path__ + "static/media/galleryhead.aa886b88d8657a17f4b6b1ff3ccb4e64.svg";
export { ForwardRef as ReactComponent };